import { Component, OnInit } from '@angular/core';
import { LoggingMessageService } from '../services/logging-message.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-blank-page',
  templateUrl: './blank-page.component.html',
  styleUrls: ['./blank-page.component.scss']
})
export class BlankPageComponent implements OnInit {
  selectedSubscriptionID: number;
  availableSubscriptions: string;


  constructor(private logger: LoggingMessageService,
    private sessionService:StorageService) {
    this.logger.info('blank-page.component', 'BlankPageComponent Constructor', this.selectedSubscriptionID, this.availableSubscriptions,  ``, '');
  }

  ngOnInit() {
    this.selectedSubscriptionID = this.sessionService.getSubscription();
    this.availableSubscriptions = this.sessionService.getSubscriptionsAvailable();
    this.logger.info('blank-page.component', 'BlankPageComponent ngOnInit', this.selectedSubscriptionID, this.availableSubscriptions,  `ngOnInit`, '');
  }

}
